import { Text, Tooltip } from '@shopify/polaris';

/**
 * The small ⓘ next to a label.
 *
 * One component because there were three byte-identical ones — `Tip` in SkuMapTable,
 * `ConnectorInfoTip` in ConnectorTab and `InfoTip` in Connector — which is how the three
 * slowly stopped matching.
 *
 * Only for a CAVEAT on one value. What a card or a column is FOR belongs in text under its
 * heading: hiding the subject of a section behind a hover is the trade this codebase has
 * already reversed twice.
 */
export default function InfoTip({ content }) {
  return (
    <Tooltip content={content}>
      <Text variant="bodySm" tone="subdued">&#9432;</Text>
    </Tooltip>
  );
}
